import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, CircularProgress, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

function PaymentSuccess() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { token } = useAuth();
  const sessionId = searchParams.get('session_id');

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        await axios.post(
          `${API_URL}/verify-payment`,
          { sessionId },
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        setLoading(false);
      } catch (err) {
        setError('Failed to verify payment. Please contact support.');
        setLoading(false);
      }
    };

    if (sessionId) {
      verifyPayment();
    }
  }, [sessionId, token]);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Verifying your payment...</Typography>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
        <Typography color="error" gutterBottom>{error}</Typography>
        <Button variant="contained" onClick={() => navigate('/pricing')}>
          Return to Pricing
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
      <Box sx={{ mb: 4 }}>
        <CheckCircleIcon sx={{ fontSize: 64, color: '#00ffea' }} />
      </Box>
      <Typography variant="h4" gutterBottom sx={{ color: '#00ffea' }}>
        Payment Successful!
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        Thank you for your subscription. Your account has been upgraded.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/image-generator')}
        sx={{
          bgcolor: '#00ffea',
          color: '#000',
          '&:hover': {
            bgcolor: '#00b8ff'
          }
        }}
      >
        Start Generating Images
      </Button>
    </Container>
  );
}

export default PaymentSuccess; 